/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_file_txt': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M-2-2h24v24H-2z"/><path pid="1" d="M0 0h20v20H0V0zm5 4v12h10V4H5zm2 3h6v1H7V7zm0 3h6v1H7v-1zm0 3h6v1H7v-1z" _fill="#B4B4B4"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_file_txt.js